import React from 'react';
import { Zap, Brain, Flame, Moon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-272">
      <div className="max-w-5xl mx-auto" data-id="element-273">
        <div className="text-center mb-14 md:mb-20" data-id="element-274">
          <span className="inline-block bg-emerald-50 text-emerald-700 font-bold py-2 px-6 rounded-full mb-6 text-sm uppercase tracking-wider border border-emerald-100" data-id="element-275">
            ✅ La solución para tu etapa
          </span>
          <h2 className="text-3xl md:text-6xl font-black text-gray-900 mb-4 tracking-tight" data-id="element-276">
            Manual de Biohacking <br data-id="element-277" />
            <span className="text-emerald-600" data-id="element-278">+ 800 Recetas</span>
          </h2>
          <p className="text-xl md:text-3xl font-serif italic text-gray-500 mb-6" data-id="element-279">
            para la Pre y Postmenopausia
          </p>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-280">
            Un sistema completo de alimentación consciente + biohacking,
            diseñado específicamente para equilibrar tus hormonas y recuperar tu
            vitalidad.
          </p>
        </div>

        {/* Benefit Cards - stacked on mobile, row on desktop */}
        <div className="space-y-3 md:space-y-0 md:grid md:grid-cols-5 md:gap-4 mb-16 md:mb-20" data-id="element-281">
          {[{
          icon: '🥑',
          text: 'Comer rico y saludable'
        }, {
          icon: <Zap className="w-6 h-6 text-amber-500" data-id="element-282" />,
          text: 'Recuperar energía'
        }, {
          icon: <Brain className="w-6 h-6 text-purple-500" data-id="element-283" />,
          text: 'Claridad mental'
        }, {
          icon: <Flame className="w-6 h-6 text-rose-500" data-id="element-284" />,
          text: 'Reducir inflamación'
        }, {
          icon: <Moon className="w-6 h-6 text-indigo-500" data-id="element-285" />,
          text: 'Dormir mejor'
        }].map((item, idx) => <div key={idx} className="flex md:flex-col items-center gap-4 md:gap-3 p-4 md:p-6 rounded-2xl border border-gray-100 md:text-center md:h-44 md:justify-center" data-id="element-286">
              <div className="text-3xl md:text-4xl shrink-0" data-id="element-287">{item.icon}</div>
              <p className="font-bold text-gray-800 text-base md:text-sm leading-tight" data-id="element-288">
                {item.text}
              </p>
            </div>)}
        </div>

        {/* Steps */}
        <div className="border border-gray-100 rounded-3xl p-8 md:p-16" data-id="element-289">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 relative" data-id="element-290">
            {[{
            step: '1',
            title: 'Abrís',
            desc: 'el manual digital'
          }, {
            step: '2',
            title: 'Elegís',
            desc: 'qué comer hoy'
          }, {
            step: '3',
            title: 'Cocinás',
            desc: 'sin pensar'
          }, {
            step: '4',
            title: 'Sentís',
            desc: 'el cambio real'
          }].map((s, i) => <div key={i} className="text-center" data-id="element-291">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center text-2xl font-black mx-auto mb-4 border border-emerald-100" data-id="element-292">
                  {s.step}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1" data-id="element-293">
                  {s.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base" data-id="element-294">{s.desc}</p>
              </div>)}
          </div>
        </div>

        <div className="mt-12 md:mt-16 text-center" data-id="element-295">
          <p className="text-xl md:text-2xl font-serif italic text-gray-800 max-w-3xl mx-auto" data-id="element-296">
            Sin dietas extremas. Sin complicarte. Sin sufrir los síntomas en
            silencio.
          </p>
        </div>
      </div>
    </section>;
}